import type { CommercialAccess } from "@rakazo/contracts";
import { createContext, useContext } from "react";

export const CommercialContext = createContext(false);
export const CommercialAccessContext = createContext<CommercialAccess | null>(null);
export const CommercialActionsContext = createContext({
  requireAccess: async (): Promise<boolean> => true,
  handleAccessError: (_error: unknown): boolean => false,
});
export function useCommercialActions() {
  return useContext(CommercialActionsContext);
}
export function isCommercialAccessError(error: unknown): boolean {
  if (!error || typeof error !== "object" || !("code" in error)) return false;
  return error.code === "SUBSCRIPTION_REQUIRED" || error.code === "WORKSPACE_REVOKED";
}
export function useCommercialAccess() {
  return useContext(CommercialAccessContext);
}
export function useCommercialMode() {
  return useContext(CommercialContext);
}
